import {
  CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST,
  CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST,
  FETCH_REIMBURSEMENT_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_SUBHEADS_REQUEST,
  SAVE_REIMBURSEMENT_HEAD_REQUEST,
  SAVE_REIMBURSEMENT_SUBHEAD_REQUEST,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE,
  FETCH_MAPPED_HEADS_REQUEST,
  SAVE_MAPPED_HEAD_REQUEST,
  CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS,
  FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE,
} from './actionTypes';

export const fetchReimbursementHeads = (unit_id, create_by) => ({
  type: FETCH_REIMBURSEMENT_HEADS_REQUEST,
  payload: { unit_id, create_by }
});

export const saveReimbursementHead = (payload) => ({
  type: SAVE_REIMBURSEMENT_HEAD_REQUEST,
  payload,
});

export const changeReimbursementHeadStatus = (payload) => ({
  type: CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST,
  payload,
});

// Fetch Subheads
export const fetchReimbursementSubheads = (unit_id) => ({
  type: FETCH_REIMBURSEMENT_SUBHEADS_REQUEST,
  payload: { unit_id },
});

// Save Subhead
export const saveReimbursementSubhead = (payload) => ({
  type: SAVE_REIMBURSEMENT_SUBHEAD_REQUEST,
  payload,
});

// Change Subhead Status
export const changeReimbursementSubheadStatus = (payload) => ({
  type: CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST,
  payload,
});

export const fetchReimbursementMappedheads = (unit_id, head_id, create_by) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST,
  payload: { unit_id, head_id, create_by },
});

export const fetchReimbursementMappedheadsSuccess = (data) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS,
  payload: data,
});

export const fetchReimbursementMappedheadsFailure = (error) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE,
  payload: error,
});

export const fetchMappedHeads = (unit_id) => ({
  type: FETCH_MAPPED_HEADS_REQUEST,
  payload: { unit_id }
});

export const saveMappedHead = (payload) => ({
  type: SAVE_MAPPED_HEAD_REQUEST,
  payload,
});

export const changeMappedHeadStatus = (payload) => ({
  type: CHANGE_MAPPED_HEAD_STATUS_REQUEST,
  payload,
});

export const fetchReimbursementGridHeads = (unit_id) => ({
  type: FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST,
  payload: { unit_id },
});

export const fetchReimbursementGridHeadsSuccess = (data) => ({
  type: FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS,
  payload: data,
});

export const fetchReimbursementGridHeadsFailure = (error) => ({
  type: FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE,
  payload: error,
});

export const fetchReimbursementMappedsubheads = (unit_id, head_id) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST,
  payload: { unit_id, head_id },
});

export const fetchReimbursementMappedsubheadsSuccess = (data) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS,
  payload: data,
});

export const fetchReimbursementMappedsubheadsFailure = (error) => ({
  type: FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE,
  payload: error,
});